import { type ChartData, type ChartOptions } from 'chart.js';
import { useMemo } from 'react';
import { Bar } from 'react-chartjs-2';
import './waterfall-tooltip-bar.component.scss';

interface WaterfallTooltipBarProps {
  value: number;
  max: number;
  min: number;
  color: string;
}
export const WaterfallTooltipBar = ({
  value,
  max,
  min,
  color,
}: WaterfallTooltipBarProps) => {
  const chartData = useMemo(() => {
    const ret: ChartData<'bar', any[]> = {
      labels: ['Impact'],
      datasets: [
        {
          label: 'Impact',
          data: [value],
          backgroundColor: color,
        },
      ],
    };
    return ret;
  }, [value, color]);
  const options: ChartOptions<'bar'> = useMemo(() => {
    return {
      indexAxis: 'y',
      plugins: {
        title: {
          display: false,
        },
        legend: {
          display: false,
        },
        tooltip: {
          enabled: false,
        },
      },
      responsive: true,

      scales: {
        x: {
          display: false,
          min,
          max,
          //beginAtZero: true
        },
        y: {
          display: false,
        },
      },
    };
  }, [min, max]);
  return <Bar height={80} options={options} data={chartData} />;
};
